import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import { AddCartLinesDocument, type AddCartLinesMutation } from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCartToCart } from './graphql'

type CreateCartLineInput = Readonly<{
  merchandiseId?: string
  quantity?: number
}>[]

export const createCartLine =
  (options: GlobalRequestOptions) =>
  async (cartId: string, lines: CreateCartLineInput): Promise<Cart> => {
    const response = await storefrontClient.request<AddCartLinesMutation>(
      print(AddCartLinesDocument),
      {
        variables: {
          cartId,
          lines,
          language: options.language,
        },
      },
    )

    const payload = response.data?.cartLinesAdd

    if (!payload?.cart) {
      throw new Error('Failed to create line item')
    }

    return mapGQLCartToCart(payload.cart)
  }
